import NBType, { InferType } from '@netbase/nb-type'
import { AuthorSex, StreamSymbol } from 'enums'
import AggregateResultSchema from 'schemas/AggregateResultSchema'
import SocialWebChannelSchema from 'schemas/SocialWebChannelSchema'
import GroupMetricResultSchema from 'schemas/GroupMetricResultSchema'

const InsightDataSchema = NBType.object().shape('InsightDataSchema', {
  authorFingerprint: NBType.string(),
  count: NBType.number(),
  name: NBType.string(),
  share: NBType.number(),
  sum: NBType.number(),
  value: NBType.number(),
  // below are fields required for geo chart
  id: NBType.string(),
  geoType: NBType.string(),
  info: NBType.string(),
  perCapita: NBType.number(),
  population: NBType.string(),
  isoName: NBType.string(),
  latitude: NBType.number(),
  longitude: NBType.number(),
  parentId: NBType.string(),
  // below are fields required for author chart
  authorAvatarUrl: NBType.string(),
  authorDescription: NBType.string(),
  authorHandle: NBType.string(),
  authorID: NBType.string(),
  authorLink: NBType.string(),
  authorName: NBType.string(),
  authorVerified: NBType.boolean(),
  dataStreams: NBType.array().of(NBType.enum(StreamSymbol)),
  domain: NBType.string(),
  engagements: NBType.number(),
  followers: NBType.number(),
  mentions: NBType.number(),
  sex: NBType.enum(AuthorSex),
  // below are fields required for demographic
  index: NBType.number(),
  // below are fields required for trending
  // trend might be number or the string 'NaN'
  trend: NBType.mixed<number | string>(),
  aggregateResult: AggregateResultSchema.nullable().optional(),
  stemmedForm: NBType.string(),
  variants: NBType.array().of(NBType.string()),
  insightType: NBType.string().nullable().optional(),
  // topic comparison
  topicId: NBType.number(),
  topicName: NBType.string(),
  // photo concept
  enumName: NBType.string(),
  // channels
  channelInfo: SocialWebChannelSchema.nullable().optional(),
  groupMetricResults: NBType.array().of(GroupMetricResultSchema).nullable().optional(),
  image: NBType.string().optional(),
  // tags
  level: NBType.number(),
  searchName: NBType.string(),
  children: NBType.array().of(NBType.string()),
  overallStarRatingsAverage: NBType.number(),
  overallSurveyScoresAverage: NBType.number(),
  // timeline
  startDatetime: NBType.number(),
  endDatetime: NBType.number(),
  timeInterval: NBType.string()
})

export default InsightDataSchema
export type InsightData = InferType<typeof InsightDataSchema>
// RESERVE BELOW
